import React, { useEffect, useState } from 'react';
import CallPractice from './CallPractice';
import classes from './AICallingInterface.module.scss';
import CustomizeAI from './CustomizeAI';
import { getRequest } from '../../helpers/httpHandler2';

export interface Prompt {
  text: string;
  id: number;
}

const AICallingInterface: React.FC = () => {
  const [activeTab, setActiveTab] = React.useState<
    'callPractice' | 'customizeAI'
  >('callPractice');
  const [prompt, setPrompt] = useState<Prompt>();

  useEffect(() => {
    const getPromt = async () => {
      try {
        const response = await getRequest('/api/ai/prompt');
        setPrompt(response);
      } catch (error) {
        // Optionally set an error state here for UI feedback
        console.error('Error fetching prompt:', error);
      }
    };
    getPromt();
  }, []);

  return (
    <div className={classes['container']}>
      <div className={classes['background']}>
        {/* Animated background particles */}
        <div className={classes['particles']}>
          {[...Array(50)].map((_, i) => (
            <div
              key={i}
              className={classes['particle']}
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
                animationDuration: `${3 + Math.random() * 4}s`
              }}
            />
          ))}
        </div>

        {/* Top Navigation */}
        <div className={classes.topNav}>
          <div className={classes.tabContainer}>
            <button
              className={[
                classes.tab,
                activeTab === 'callPractice' ? classes.activeTab : ''
              ].join(' ')}
              onClick={() => setActiveTab('callPractice')}
            >
              Call Practice
            </button>
            <button
              className={[
                classes.tab,
                activeTab === 'customizeAI' ? classes.activeTab : ''
              ].join(' ')}
              onClick={() => setActiveTab('customizeAI')}
            >
              Customize AI
            </button>
          </div>
        </div>

        {activeTab === 'callPractice' && <CallPractice prompt={prompt} />}
        {activeTab === 'customizeAI' && (
          <CustomizeAI prompt={prompt} setPrompt={setPrompt} />
        )}
      </div>
    </div>
  );
};

export default AICallingInterface;
